import { CQAInvoice, WorkItemEnhanced } from "../../../types/cqa";
import { Box, Chip, Stack } from "@mui/material";
import theme from "../../../theme/Theme";

interface Props {
    data: WorkItemEnhanced;
}

interface CodesPerType {
    procedure: string[];
    diagnosis: string[];
    modifier: string[];
}

const displayCodes = (codes: CodesPerType) => {
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {/* Procedure Codes */}
            {codes.procedure.map((code, index) => (
                <Chip
                    key={`procedure-${index}`}
                    label={code}
                    size="small"
                    sx={{
                        backgroundColor: theme.palette.artisticTagsGreen50.main,
                        color: theme.palette.artisticTagsGreen500.main,
                        fontSize: '12px'
                    }}
                />
            ))}
            
            {/* Modifier Codes */}
            {codes.modifier.map((code, index) => (
                <Chip
                    key={`modifier-${index}`}
                    label={code}
                    size="small"
                    sx={{
                        backgroundColor: theme.palette.artisticTagsBlue50.main,
                        color: theme.palette.artisticTagsBlue500.main,
                        fontSize: '12px'
                    }}
                />
            ))}
            
            {/* Diagnosis Codes */}
            {codes.diagnosis.map((code, index) => (
                <Chip
                    key={`diagnosis-${index}`}
                    label={code}
                    size="small"
                    sx={{
                        backgroundColor: theme.palette.artisticTagsPlum50.main,
                        color: theme.palette.artisticTagsPlum500.main,
                        fontSize: '12px'
                    }}
                />
            ))}
        </Box>
    );
};

//For each tx we will get the codes and then we will return a list of codes for each type
const compileCodesFromInvoices = (cqaInvoices: CQAInvoice[]): CodesPerType[] => {
    const allTx = cqaInvoices.flatMap((invoice) => invoice.transactions);

    return allTx.map((tx) => ({
        procedure: tx.procedures.map((p) => p.code),
        diagnosis: tx.diagnoses.map((d) => d.code),
        modifier: tx.modifiers.map((m) => m.code)
    }));
};

const CQACodersCell = ({ data }: Props): JSX.Element | null => {    
    const cqaInvoices = data.cqa_invoices;

    if(!cqaInvoices || cqaInvoices.length === 0){
        return null;
    }

    const codeRows = compileCodesFromInvoices(cqaInvoices);

    return (
        <Stack spacing={1} paddingY={1}>
            {codeRows.map((codes, index) => (
                <Box key={index}>
                    {displayCodes(codes)}
                </Box>
            ))}
        </Stack>
    );
};

export default CQACodersCell;